import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Loader } from '../../_components';
import { settingsActions } from '../../_actions';

import { Company } from './_components/Company.modal';

import './Settings.scss';

class SettingsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: 'Company',
      icon: 'lnr-cog',
      subtitle: 'Here you can change and view your company data',
      type: 'company',
      view: false,
      edit: false,
      companyUuid: JSON.parse(sessionStorage.getItem('cellit_userdata')).company_uuid,
      domain: queryString.parse(this.props.location.search).domain,
      updating: true
    }

    this.handleAction = this.handleAction.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
  }

  componentDidMount() {
    document.title = "Settings - Cellit.io";

    const { dispatch } = this.props;
    const { companyUuid } = this.state;

    dispatch(settingsActions.listCompany(companyUuid))
      .then(res => {
        if ( res.type === 'ALERT_FAILURE' ) return;
        
        if (res.data.data.document) {
          this.setState({
            companyData: res.data.data,
            edit: true,
            view: true,
          });
        }

        this.setState({updating: false});
      });
  }

  handleAction(e) {
    const target = e.currentTarget;

    this.setState({
      actionType: target.getAttribute('data-action')
    })
  }

  handleCreate() {
    this.setState({
      edit: true,
      view: true,
    })
  }

  render() {
    const { name, icon, subtitle, type, view, actionType, companyUuid, companyData, edit } = this.state;

    return(
      <section key={this.state.domain} className="component component-settings">
        <div className="component-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <h1 className="title">Settings</h1>
                <p className="subtitle"></p>
              </div>
            </div>
          </div>
        </div>
        <div className="component-body">
          {
            !this.state.updating ?
              <div className="container-fluid">
                <div className="row">
                  <ChannelGroup handleAction={this.handleAction} icon={icon} title={name} subtitle={subtitle} channelType={type} view={view} edit={edit} />
                </div>
              </div>
            : <Loader />
          }
        </div>

        {
          !this.state.updating ?
            <div>
              <Company name="company" companyUuid={companyUuid} actionType={actionType} companyData={companyData} onCreate={this.handleCreate}/>
            </div>
          : ''
        }
      </section>
    )
  }
}

class ChannelGroup extends Component {
  handleModalOpen(e) {
    let _ = e.target;

    if ( !_.checked ) {
      return _.setAttribute('data-target', '#'+_.getAttribute('name')+'Modal');
    }

    _.setAttribute('data-target', '');
  }

  render() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
        <div className="channel-card-group" data-active="true">
          <div className="row">
            <div className="col-1">
              <i className={'info-ico lnr ' + this.props.icon}></i>
            </div>
            <div className="col information">
              {
                this.props.title ?
                  <p className="channel-title">{this.props.title}</p>
                : <img src={this.props.imgSrc} className="channel-title-image" alt={this.props.title + ' logo'}/>
              }
              <p className="channel-subtitle">{this.props.subtitle}</p>
            </div>
            <div className="col-3">
              {
                this.props.edit ?
                <button className="btn btn-blue" data-toggle="modal" data-target={'#'+this.props.channelType+'Modal'} data-action="edit" onClick={this.props.handleAction.bind()}>
                  <i className="lnr lnr-pencil"></i>
                </button>
                : 
                <button className="btn btn-blue" data-toggle="modal" data-target={'#'+this.props.channelType+'Modal'} data-action="add" onClick={this.props.handleAction.bind()}>
                  <i className="lnr lnr-plus-circle"></i>
                </button>
              }
              {
                this.props.view?
                <button className="btn btn-white-outlined" data-toggle="modal" data-target={'#'+this.props.channelType+'Modal'} data-action="view" onClick={this.props.handleAction.bind()}>
                  <i className="lnr lnr-eye"></i>
                </button>
                : ''
              }
            </div>
          </div>
        </div>                
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { listedChannels } = state.listChannelsReducer;
  return listedChannels;
}

const ConnectedSettingsContainer = connect(mapStateToProps)(SettingsContainer);
export { ConnectedSettingsContainer as SettingsContainer }